// Chính sách quyền riêng tư (Luật Bảo vệ dữ liệu cá nhân 91/2025/QH15, hiệu lực 01/01/2026).
// Văn bản tóm tắt cho người dùng – phần thông tin pháp nhân [ ] cần chủ sản phẩm điền.

import { h } from '../dom';

export const POLICY_VERSION = '2026-10-05';

const SECTIONS: [string, string[]][] = [
  ['Ai xử lý dữ liệu của bạn', [
    'Booth Together do [TÊN TỔ CHỨC/CÁ NHÂN] vận hành, liên hệ: [EMAIL LIÊN HỆ].',
  ]],
  ['Chúng tôi thu thập gì', [
    'Tài khoản: email, tên hiển thị, @username, ảnh đại diện, giới thiệu.',
    'Nội dung bạn tạo: ảnh chụp booth (ảnh gốc của từng lần bấm chụp kèm khung cảnh phía sau bạn, dùng để làm ảnh lưu), bài đăng, bình luận, cảm xúc, danh sách bạn bè.',
    'Thiết bị: mã nhận thông báo (để gửi thông báo đẩy), thông tin kỹ thuật tối thiểu khi gọi máy chủ.',
  ]],
  ['Dữ liệu khuôn mặt và cơ thể', [
    'Khi xem trước, việc tách nền, nhận diện tư thế và điểm mốc khuôn mặt chạy NGAY TRÊN MÁY của bạn.',
    'Với ảnh lưu, máy chủ tách người lại từ ảnh gốc của lần chụp để viền tóc và tay sạch hơn. Việc này chỉ tạo ra ảnh ghép, không tạo hay lưu mẫu khuôn mặt.',
    'Chúng tôi KHÔNG lưu điểm mốc khuôn mặt hay mẫu sinh trắc học trên máy chủ. Vị trí tư thế chỉ được gửi trực tiếp tới người cùng phòng trong lúc chụp để ghép hình rồi bị bỏ đi.',
    'Ảnh chụp có hình bạn là dữ liệu cá nhân; chỉ những người bạn cho phép mới xem được.',
  ]],
  ['Mục đích', [
    'Cho phép bạn chụp ảnh chung, lưu, chia sẻ với bạn bè và nhận thông báo. Không bán dữ liệu, không quảng cáo theo hồ sơ cá nhân.',
  ]],
  ['Lưu trữ và chuyển ra nước ngoài', [
    'Dữ liệu được lưu trên Google Cloud tại Singapore, mã hoá khi lưu bằng khoá do chúng tôi quản lý (Cloud KMS) và truyền qua HTTPS.',
    'Thông báo đẩy đi qua Firebase Cloud Messaging (Google).',
  ]],
  ['Thời gian lưu', [
    'Bài đăng: mặc định bạn bè chỉ thấy trong 24 giờ, sau đó chỉ bạn và người trong ảnh còn xem được. Bạn có thể bật tự xoá hẳn bài đăng sau 24 giờ (Tôi → Quyền riêng tư). Bài bạn đã xoá bị xoá hẳn khỏi máy chủ sau 24 giờ.',
    'Ảnh chụp và dữ liệu khác: đến khi bạn xoá nội dung hoặc xoá tài khoản. Bản sao lưu cơ sở dữ liệu được giữ tối đa 7 ngày.',
  ]],
  ['Mã nguồn và giấy phép', [
    'Booth Together là phần mềm tự do theo giấy phép GNU GPL v3.0. Toàn bộ mã nguồn ở github.com/siguna/photobooth-online.',
    'Thành phần bên thứ ba: MODNet, PP-HumanSeg, MediaPipe, Firebase (Apache-2.0), ONNX Runtime, Capacitor, Trystero (MIT), phông Be Vietnam Pro, Baloo 2 (OFL). Chi tiết trong NOTICE.md của mã nguồn.',
  ]],
  ['Quyền của bạn', [
    'Biết, đồng ý hoặc rút lại đồng ý, xem và tải dữ liệu của mình (Tôi → Tải dữ liệu của tôi), chỉnh sửa, và xoá tài khoản cùng toàn bộ dữ liệu (Tôi → Xoá tài khoản).',
    'Người dưới 16 tuổi cần có sự đồng ý của cha mẹ hoặc người giám hộ.',
  ]],
];

export function policyBody() {
  return h('div.policy', {},
    h('p.tiny.left', {}, `Phiên bản ${POLICY_VERSION}`),
    ...SECTIONS.map(([title, items]) => h('section', {},
      h('h3', {}, title),
      h('ul', {}, ...items.map((t) => h('li', {}, t))))));
}

export function renderPrivacy(root: HTMLElement) {
  root.replaceChildren(h('main.policypage', {},
    h('a.link', { href: history.length > 1 ? 'javascript:history.back()' : '#/login' }, '← Quay lại'),
    h('h1', {}, 'Chính sách quyền riêng tư'),
    policyBody()));
}
